import React from 'react';

import DefaultButton from 'components/button/DefaultButton';
import Localization from 'i18n';

const ModifyButton = (props) => (
  <DefaultButton size="md" {...props}>{Localization.modifyPatient}</DefaultButton>
);

export default ModifyButton;